import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { BookingResponse } from 'app/typings/core/admin/bookings/booking';
import type { ReviewFormRequest } from 'app/typings/core/admin/bookings/bookingForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS as BOOKING_QUERY_KEY } from '../bookings';

import { ENDPOINTS } from '.';

type UpdateReviewParams = {
  reviewId: number;
  bookingCode: string;
  payload: ReviewFormRequest;
};

export function useUpdateReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ reviewId, payload }: UpdateReviewParams) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.editReview,
          params: { reviewId: reviewId.toString() },
        },
        payload
      ) as Promise<BookingResponse>,
    onSuccess: (response, variables) => {
      message.success('Review successfully updated');

      queryClient.invalidateQueries([
        BOOKING_QUERY_KEY.booking,
        { code: variables.bookingCode },
      ]);
    },
    onError: () => {
      message.error('Failed to update review');
    },
  });
}
